const BASE_URL = "https://krumago-application-assets.s3.us-east-1.amazonaws.com/Assessment-Domain-Assets/";

export const ASSESSMENT = {
    IMAGES: {
        IMAGE_1: `${BASE_URL}freepik__the-style-is-candid-image-photography-with-natural__74004.jfif`,
        IMAGE_2: `${BASE_URL}freepik__the-style-is-candid-image-photography-with-natural__74005.jfif`,
        IMAGE_3: `${BASE_URL}freepik__the-style-is-candid-image-photography-with-natural__74006.jfif`,
        IMAGE_4: `${BASE_URL}freepik__the-style-is-candid-image-photography-with-natural__74007.jfif`,
        IMAGE_5: `${BASE_URL}freepik__the-style-is-candid-image-photography-with-natural__74008.jfif`,
        IMAGE_6: `${BASE_URL}freepik__the-style-is-candid-image-photography-with-natural__74009.jfif`,
    },
};
